import { render, staticRenderFns } from "./ModalCustomizeColumns.vue?vue&type=template&id=b712f01e&"
import script from "./ModalCustomizeColumns.vue?vue&type=script&lang=js&"
export * from "./ModalCustomizeColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports